import { useState } from "react";

type UsePaginationArgs = {
  initialPage?: number;
  initialPageSize?: number;
};

export const usePagination = ({
  initialPage = 1,
  initialPageSize = 20,
}: UsePaginationArgs = {}) => {
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [total, setTotal] = useState(0);

  const resetPagination = () => {
    setPage(1);
    setPageSize(initialPageSize);
    setTotal(0);
  };

  return {
    page,
    pageSize,
    total,
    setPage,
    setPageSize,
    setTotal,
    resetPagination,
  };
};
